/**
 * @desc 更新
 */
import {
  PriceIndexEntity,
  PriceIndexForm
} from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdatePriceIndexParameter = PriceIndexForm

const method = 'PUT'
const url = '/content/operation/priceIndex'

export const updatePriceIndexApi = (
  data?: UpdatePriceIndexParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PriceIndexEntity>({
    method,
    url,
    data,
    ...config
  })
}

updatePriceIndexApi.method = method
updatePriceIndexApi.url = url
